// Which farm animal a tap / click lands on (FarmAnimalLayer.animalAtScreen), pure. Its sprite
// counts with a little margin, and so does the milk / egg bubble above it — the thing a child taps
// to collect (owner 2026-09-30: a click on an animal with milk often did nothing). Front-most wins.
export const PICK_PAD = 10;                     // world px around the sprite

const hit = (r, x, y, pad = 0) => !!r && x >= r.x - pad && x <= r.x + r.w + pad && y >= r.y - pad && y <= r.y + r.h + pad;

// Order: a sprite whose drawn pixel is under the pointer (`opaque`, when the caller knows it) —
// front-most of those; then a sprite box or a bubble — front-most; then only the margins — the
// nearest centre. In a crowd the boxes overlap mostly on transparent corners (owner 2026-09-30).
export function pickAnimal(items, x, y) {
  const front = (list) => list.reduce((best, it) => (!best || it.depth > best.depth ? it : best), null);
  const solid = items.filter((it) => it.opaque === true && hit(it.body, x, y));
  if (solid.length) return front(solid);
  const direct = items.filter((it) => it.opaque !== false && hit(it.body, x, y) || hit(it.bubble, x, y));
  if (direct.length) return front(direct);
  const centre = (r) => [r.x + r.w / 2, r.y + r.h / 2];
  const near = items.filter((it) => hit(it.body, x, y, PICK_PAD) || hit(it.bubble, x, y, PICK_PAD))
    .map((it) => ({ it, d: Math.hypot(x - centre(it.body)[0], y - centre(it.body)[1]) }));
  if (!near.length) return null;
  const dmin = Math.min(...near.map((n) => n.d));
  return front(near.filter((n) => n.d - dmin < 1e-9).map((n) => n.it));
}
